import React, { memo } from 'react';
import { Box3, Vector3 } from 'three';

import { RaycastOrder } from '@paragon/three-shared';

export interface BoundingHitBoxProps {
  box3: Box3;
  mouseDown: () => void;
  debug?: true;
}

export const BoundingHitbox = memo((props: BoundingHitBoxProps) => {
  const position = new Vector3();
  props.box3.getCenter(position);

  const { min, max } = props.box3;
  const scale = max.clone().sub(min);

  return (
    <mesh
      position={position}
      scale={scale}
      userData-raycastOrder={RaycastOrder.BoundingHitBox}
      onClick={(event) => event.stopPropagation()}
      onPointerDown={(event) => {
        event.stopPropagation();
        props.mouseDown();
      }}
    >
      <meshBasicMaterial depthWrite={false} depthTest={false} transparent opacity={props.debug ? 1 : 0} />
      <boxGeometry args={[1, 1, 1]} />
    </mesh>
  );
});
